export const CastingsTypes = [
  "actor",
  "director",
  "producer",
  "author",
  "sale",
  "contact",
];
